import React, { FC, useState } from "react";
import { Link } from "gatsby";
import { cleanURL } from "../../helpers";
import { arrowDownIcon } from "../../images/svgIcons";
import CaruselElem from "./carusel-elem";
import "./styles.scss";

interface AutomationCardCaruselProps {
  lists: any[];
  loading: boolean;
  className?: string;
}

const AutomationCardCarusel: FC<AutomationCardCaruselProps> = ({
  lists,
  loading,
  className,
}) => {
  const [scroll, setScroll] = useState(0);
  const [isScroll, setIsScroll] = useState(false);

  const scrollLeft = () => {
    if (!scroll) return;
    const el = document.querySelector(className ? "." + className : ".fields");
    if (el) {
      if (el.scrollLeft > 0) el.scrollLeft -= 280;
      setScroll(el.scrollLeft);
      setIsScroll(el.scrollWidth - el.clientWidth === el.scrollLeft);
    }
  };

  const scrollRight = () => {
    const el = document.querySelector(className ? "." + className : ".fields");
    if (el) {
      if (el.scrollWidth - el.clientWidth === el.scrollLeft) return;
      if (el.scrollLeft <= el.scrollWidth) el.scrollLeft += 280;
      setScroll(el.scrollLeft);
      setIsScroll(el.scrollWidth - el.clientWidth === el.scrollLeft);
    }
  };

  return (
    <>
      {loading ? (
        <div className="pulse-placeholder-card">
          <div className="card-placeholder"></div>
          <div className="card-placeholder"></div>
          <div className="card-placeholder"></div>
        </div>
      ) : (
        <div className="fields-wrapper">
          <div
            onClick={scrollLeft}
            className={`icon left-icon ${!scroll ? "disabled" : ""}`}
          >
            {arrowDownIcon}
          </div>
          <div
            className={`fields overflow-auto no-wrap mx-2 ${
              className ? className : ""
            }`}
          >
            {lists.map((list: any) => (
              <Link to={`/automation/${cleanURL(list.url)}`}>
                <CaruselElem
                  dscription={list.long_description}
                  type={list.type}
                  title={list.name}
                  icon={list.icon_url}
                  text={list.name}
                  is_new={list.is_new}
                />
              </Link>
            ))}
          </div>
          <div
            onClick={scrollRight}
            className={`icon right-icon ${isScroll ? "disabled" : ""}`}
          >
            {arrowDownIcon}
          </div>
        </div>
      )}
    </>
  );
};
export default AutomationCardCarusel;
